<script setup lang="ts">
import {
  defineProps,
} from 'vue';
import {
  CdrText, IconCaretRight, CdrButton,
} from '@rei/cedar';
import { format } from 'date-fns';
import OrderImageGrid from './OrderImageGridBeta.vue';
import { sendClickAnalytics } from '../../utils';
import tags from '../../utils/globalTags';

const props = defineProps<{
  ordersByYear: any[],
  orderId: any,
}>();

const orderIdStyle = () => {
  if (props.orderId) {
    return {
      'pointer-events': 'none',
      outline: '3px solid #928B80',
      border: '0',
    };
  }
  return {};
};

const metricHandler = (source = 'online') => {
  const name = tags.HELP;
  const clickData = {
    pageName: name,
    linkName: `${tags.HELP_CENTER_MY_ORDERS}_${source}`,
  };
  sendClickAnalytics(clickData);
};

const redirectToOrderHelp = (orderId: string, index: number) => {
  const tagPrefix = `${index + 1}_`;
  const orderTag = `${tagPrefix}Main`;
  metricHandler(orderTag);
  sessionStorage.setItem('orderId', orderId);
  const orderFiltered = props.ordersByYear?.filter((orders: any) => orders.orderId === orderId);
  sessionStorage.setItem('filteredOrder', JSON.stringify(orderFiltered));
  window.open('/help/my-orders', '_self');
};

const getFulfillItems = (order: { fulfillmentGroups: any[]; }) => {
  const fullFillItems = order?.fulfillmentGroups?.map((group) => group.fulfillmentItems);
  return fullFillItems.flat(1);
};
</script>

<template>
  <div
    id="order-details-main"
    class="order-details-main"
  >
    <div
      v-for="(order, index) in ordersByYear"
      :key="index"
      class="order-details-box"
      :data-ui="order?.orderId"
    >
      <CdrButton
        tabindex="0"
        :tag="props?.orderId ? 'div' : 'button'"
        class="order-details-sectionValues"
        :style="orderIdStyle()"
        @click="redirectToOrderHelp(order.orderId, index)"
      >
        <div class="order-details-secVal">
          <div class="order-details-secVal-details">
            <CdrText class="order-details-sec-heading">
              Ordered on {{ format(new Date(order.orderDate), 'MMM dd yyyy' ) }}
            </CdrText>
            <CdrText class="order-details-sec-body">
              Order number: {{ order.orderId }}
            </CdrText>
          </div>
          <IconCaretRight
            v-if="!props.orderId"
            class="order-details-right-icon"
          />
        </div>
        <div v-if="(order?.fulfillmentGroups && order?.fulfillmentGroups.length > 0)">
          <OrderImageGrid
            :fulfillment-items="getFulfillItems(order)"
          />
        </div>
      </CdrButton>
    </div>
  </div>
</template>

<style scoped></style>
